var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLeftDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 22.9393,
    viewBox: "0 0 24 22.9393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 1.5C21.3978 1.5 21.7794 1.65804 22.0607 1.93934C22.342 2.22064 22.5 2.60218 22.5 3V15C22.5 15.3978 22.342 15.7794 22.0607 16.0607C21.7794 16.342 21.3978 16.5 21 16.5H6.621C5.82542 16.5002 5.06248 16.8164 4.5 17.379L1.5 20.379V3C1.5 2.60218 1.65804 2.22064 1.93934 1.93934C2.22064 1.65804 2.60218 1.5 3 1.5H21ZM3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3L0 22.1895C3.15223e-05 22.3379 0.0440889 22.483 0.126596 22.6063C0.209103 22.7297 0.32635 22.8258 0.463499 22.8825C0.600648 22.9392 0.751531 22.9539 0.897054 22.9248C1.04258 22.8957 1.1762 22.8241 1.281 22.719L5.5605 18.4395C5.84174 18.1582 6.22321 18.0001 6.621 18H21C21.7956 18 22.5587 17.6839 23.1213 17.1213C23.6839 16.5587 24 15.7957 24 15V3C24 2.20435 23.6839 1.44129 23.1213 0.87868C22.5587 0.316071 21.7956 0 21 0L3 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.5 9C7.5 9.39782 7.34196 9.77936 7.06066 10.0607C6.77936 10.342 6.39782 10.5 6 10.5C5.60218 10.5 5.22064 10.342 4.93934 10.0607C4.65804 9.77936 4.5 9.39782 4.5 9C4.5 8.60218 4.65804 8.22064 4.93934 7.93934C5.22064 7.65804 5.60218 7.5 6 7.5C6.39782 7.5 6.77936 7.65804 7.06066 7.93934C7.34196 8.22064 7.5 8.60218 7.5 9ZM13.5 9C13.5 9.39782 13.342 9.77936 13.0607 10.0607C12.7794 10.342 12.3978 10.5 12 10.5C11.6022 10.5 11.2206 10.342 10.9393 10.0607C10.658 9.77936 10.5 9.39782 10.5 9C10.5 8.60218 10.658 8.22064 10.9393 7.93934C11.2206 7.65804 11.6022 7.5 12 7.5C12.3978 7.5 12.7794 7.65804 13.0607 7.93934C13.342 8.22064 13.5 8.60218 13.5 9ZM19.5 9C19.5 9.39782 19.342 9.77936 19.0607 10.0607C18.7794 10.342 18.3978 10.5 18 10.5C17.6022 10.5 17.2206 10.342 16.9393 10.0607C16.658 9.77936 16.5 9.39782 16.5 9C16.5 8.60218 16.658 8.22064 16.9393 7.93934C17.2206 7.65804 17.6022 7.5 18 7.5C18.3978 7.5 18.7794 7.65804 19.0607 7.93934C19.342 8.22064 19.5 8.60218 19.5 9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLeftDots);
export default __webpack_public_path__ + "static/media/chat-left-dots.9138bac0f3b533feac6047c58d46d1bb.svg";
export { ForwardRef as ReactComponent };